import { createRouter, createWebHistory } from 'vue-router'
import HomePage from '@/components/HomePage.vue'
import LoginRegister from '@/components/LoginRegister.vue'
import NewAgent from '@/components/NewAgent.vue'
import UserManagement from '@/components/Users.vue'
import AgentDemo from '@/components/AgentDemo.vue'
import AdminPage from '@/components/Admin.vue'
import { getAccessToken, getRefreshToken, isTokenExpired, decodeToken, clearTokens, setRouter } from '@/services/auth'

const routes = [
  { path: '/', component: LoginRegister },
  { path: '/home', component: HomePage },
  { path: '/agents/new', component: NewAgent },
  { path: '/users', component: UserManagement },
  { path: '/admin', component: AdminPage },
  { path: '/demo/:subdomain', component: AgentDemo }
]

const router = createRouter({
  history: createWebHistory(),
  routes
})

setRouter(router);

// Global navigation guard for authentication and authorization.
// The session is considered valid as long as the refresh token is still
// usable - the access token itself is renewed silently in the background
// (see services/auth.js), so it is not what decides whether to log out here.
router.beforeEach((to, from, next) => {
  const publicPaths = ['/']; // Add more public paths if needed
  const isPublic = publicPaths.includes(to.path) || to.path.startsWith('/demo/');
  const refreshToken = getRefreshToken();
  const sessionValid = !!refreshToken && !isTokenExpired(refreshToken);

  if (!isPublic && !sessionValid) {
    clearTokens();
    next('/');
  } else if (to.path === '/users' || to.path === '/admin') {
    // Block non-admins from accessing these pages
    const payload = decodeToken(getAccessToken());
    if (!payload || !payload.hub_admin) {
      next('/home');
    } else {
      next();
    }
  } else {
    next();
  }
});

export default router
